// Tout le texte visible du site, dans les deux langues.
// Les mots-clés géographiques ("au Québec", "Québec, Canada") sont intégrés
// naturellement dans les phrases : c'est ce que Google lit pour associer le
// site à des recherches locales.

const translations = {
  fr: {
    nav: {
      home: "Accueil",
      about: "À propos",
      projects: "Projets",
      contact: "Contact",
      switchLabel: "English",
      switchTitle: "Read this page in English",
    },
    alert: {
      text: "Vous cherchez un développeur web full stack à Montréal ? Consultez mon",
      cv: "CV",
    },
    hero: {
      greeting: "Salut,",
      name: "moi c'est Stéphane",
      // Sert de <h1> : c'est le signal on-page le plus fort de la page.
      role: "Développeur web full stack à Montréal",
      pitch:
        "Je conçois des sites et des applications web performants en React, Next.js, Vue et .NET — de la maquette jusqu'à la mise en ligne. Basé à Montréal, je travaille avec des clients partout au Québec.",
      btnProjects: "projets",
      btnContact: "contact",
      imgAlt:
        "Illustration d'un développeur web au travail devant plusieurs écrans",
    },
    about: {
      title: "À propos",
      imgAlt:
        "Portrait de Stéphane Nkengue, développeur web full stack à Montréal",
      p1intro: "Moi c'est",
      p1name: "Stéphane Nkengue",
      p1: ", développeur web full stack établi à Montréal. Je viens d'achever mes études et je suis présentement à la recherche de nouveaux défis et opportunités. Je travaille avec JavaScript et sa longue liste de frameworks, principalement avec React.js, Next.js et Node.js, ainsi qu'avec le framework ASP.NET basé sur .NET.",
      p2: "Occasionnellement, je travaille comme développeur web freelance à Montréal et partout au Québec, où je livre des sites web hautement optimisés à mes clients et les aide à évoluer de manière numérique.",
      p3before: "Lorsque je ne code pas, je publie régulièrement sur ma",
      p3link: "newsletter TheBridge",
      p3after:
        "à propos du développement personnel. J'aime également lire, et je suis passionné de soccer depuis mon jeune âge — ça nourrit mon côté créatif quand je construis des sites web.",
      skillsTitle: "TECHNOLOGIES",
    },
    projects: {
      titleA: "récents",
      titleB: "projets",
      intro:
        "Quelques projets web réalisés pour des clients du Québec, du site vitrine à l'application transactionnelle.",
      description: "Description",
      live: "site live",
      source: "code source",
      screenshotOf: "Capture d'écran du projet",
    },
    contact: {
      title: "Votre projet est le mien !",
      text: "Vous avez un projet dont vous souhaitez discuter ? Laissez-moi un message et je vous recontacterai dans les 24 heures.",
      social: "Réseaux sociaux",
    },
    contactPage: {
      title: "contactez-moi",
      intro:
        "Si vous souhaitez travailler avec moi, remplissez le formulaire ci-dessous et je vous recontacterai dans les 24 heures.",
      or: "Vous pouvez aussi m'écrire directement à",
      name: "Nom",
      namePlaceholder: "Jean Tremblay",
      email: "Courriel",
      emailPlaceholder: "jeantremblay@exemple.com",
      message: "Comment puis-je vous aider ?",
      messagePlaceholder:
        "Nous sommes une entreprise de Montréal et nous cherchons à refaire notre site web...",
      submit: "envoyer",
      success: "Message envoyé avec succès !",
      error: "Erreur lors de l'envoi du message",
    },
    footer: {
      builtWith: "Créé avec",
      by: "par",
      tagline: "Développeur web full stack — Montréal, Québec",
    },
    error: {
      title: "404 | Page introuvable",
      heading: "Oups ! La page que vous cherchez n'existe pas 🙁",
      back: "retour à l'accueil",
    },
  },

  en: {
    nav: {
      home: "Home",
      about: "About",
      projects: "Projects",
      contact: "Contact",
      switchLabel: "Français",
      switchTitle: "Lire cette page en français",
    },
    alert: {
      text: "Looking for a full stack web developer in Montreal? Have a look at my",
      cv: "resume",
    },
    hero: {
      greeting: "Hi,",
      name: "I'm Stéphane",
      role: "Full stack web developer in Montreal",
      pitch:
        "I build fast, reliable websites and web apps with React, Next.js, Vue and .NET — from the first mockup all the way to production. Based in Montreal, working with clients across Quebec.",
      btnProjects: "projects",
      btnContact: "contact",
      imgAlt: "Illustration of a web developer working at a multi-screen desk",
    },
    about: {
      title: "About",
      imgAlt:
        "Portrait of Stéphane Nkengue, full stack web developer in Montreal",
      p1intro: "I'm",
      p1name: "Stéphane Nkengue",
      p1: ", a full stack web developer based in Montreal, Canada. I recently finished my studies and I'm currently looking for new challenges and opportunities. I work with JavaScript and its long list of frameworks, mainly React.js, Next.js and Node.js, as well as the ASP.NET framework built on .NET.",
      p2: "I also work as a freelance web developer in Montreal and across Quebec, delivering highly optimized websites to my clients and helping them grow digitally.",
      p3before: "When I'm not coding, I write regularly on my",
      p3link: "TheBridge newsletter",
      p3after:
        "about personal growth. I also enjoy reading, and I've been a soccer fan since I was young — it feeds the creative side I bring to building websites.",
      skillsTitle: "TECHNOLOGIES",
    },
    projects: {
      titleA: "recent",
      titleB: "projects",
      intro:
        "A few web projects built for clients in Quebec, from brochure sites to full transactional apps.",
      description: "Description",
      live: "live site",
      source: "source code",
      screenshotOf: "Screenshot of the project",
    },
    contact: {
      title: "Your project is my project!",
      text: "Got a project you'd like to discuss? Leave me a message and I'll get back to you within 24 hours.",
      social: "Social",
    },
    contactPage: {
      title: "get in touch",
      intro:
        "If you'd like to work with me, fill out the form below and I'll get back to you within 24 hours.",
      or: "You can also email me directly at",
      name: "Name",
      namePlaceholder: "John Smith",
      email: "Email",
      emailPlaceholder: "johnsmith@example.com",
      message: "How can I help you?",
      messagePlaceholder:
        "We're a company in Montreal and we're looking to rebuild our website...",
      submit: "send",
      success: "Message sent successfully!",
      error: "Something went wrong while sending your message",
    },
    footer: {
      builtWith: "Built with",
      by: "by",
      tagline: "Full stack web developer — Montreal, Quebec",
    },
    error: {
      title: "404 | Page not found",
      heading: "Oops! The page you're looking for doesn't exist 🙁",
      back: "back to home",
    },
  },
};

module.exports = translations;
